import React, {useState} from 'react';
import ReactJoyride, {STATUS} from "react-joyride";
import {useWindowSize} from "react-use";
// import styled from "styled-components";

export const TourGuideContext = React.createContext("");

export default function Joyride_TourGuide({children}) {

    const [{run, steps}, setState] = useState({
        run: false,
        steps: [

        ]
    });
    const {width} = useWindowSize();

    const setStepsFunc = (value) => {
        setState(prevState => ({
            ...prevState,
            steps: value,
        }))
    }
    const clearSteps = () => {
        setState(prevState => ({
            ...prevState,
            steps: [],
        }))
    }
    const handleClickStartTourGuide = (e) => {
        e.preventDefault();
        setState(prevState => ({
            ...prevState,
            run: true,
        }));
    };
    const handleClickEndTourGuide = (e) => {
        e.preventDefault();
        setState(prevState => ({
            ...prevState,
            run: false,
        }));
    };

    const handleJoyrideCallback = (data) => {
        const {status, type} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            setState(prevState => ({
                ...prevState,
                run: false,
            }));
        }
    };

    return (
        <TourGuideContext.Provider value={{
            handleClickEndTourGuide: handleClickEndTourGuide,
            handleClickStartTourGuide: handleClickStartTourGuide,
            clearSteps:clearSteps,
            setStep: setStepsFunc,
            steps: steps,
        }}>
            <ReactJoyride steps={steps}
                          run={run}
                          scrollOffset={60}
                          continuous
                          // scrollToFirstStep
                          showProgress
                          showSkipButton
                          locale={{
                              back: "قبلی",
                              close: "بستن",
                              last: "پایان",
                              next: "بعدی",
                              open: "باز کردن متن",
                              skip: "رد کن"
                          }}
                          callback={handleJoyrideCallback}
                          hideCloseButton
                          scrollDuration={width>=768?100:1000}
                          stepIndex
                          styles={{
                              options: {
                                  zIndex: 1000000000000000000,
                              },
                          }}
            />

            {children}
        </TourGuideContext.Provider>
    );
};




// for custom design
//
// const Wrapper = styled.div`
//   background-color: #ccc;
//   box-sizing: border-box;
//   min-height: 100vh;
//   padding-bottom: 50px;
//   position: relative;
// `;
//
// const TooltipBody = styled.div`
//   background-color: #daa588;
//   min-width: 290px;
//   max-width: 420px;
//   padding-bottom: 3rem;
// `;
//
// const TooltipContent = styled.div`
//   color: #fff;
//   padding: 20px;
// `;
//
// const TooltipTitle = styled.h2`
//   color: #fff;
//   padding: 20px;
//   margin: 0;
// `;
//
// const TooltipFooter = styled.div`
//   background-color: #f56960;
//   display: flex;
//   justify-content: flex-end;
//   margin-top: 1rem;
//
//   * + * {
//     margin-left: 0.5rem;
//   }
// `;
//
// const Button = styled.button`
//   background-color: #e11b0e;
//   color: #fff;
// `;
//
// const Input = styled.input`
//   padding: 1.2rem;
//   width: 75%;
// `;
//
// const Tooltip = ({
//                      continuous,
//                      index,
//                      step,
//                      backProps,
//                      closeProps,
//                      primaryProps,
//                      tooltipProps,
//                  }) => (
//     <TooltipBody {...tooltipProps}>
//         {step.title && <TooltipTitle>{step.title}</TooltipTitle>}
//         <TooltipContent>{step.content}</TooltipContent>
//         <TooltipFooter>
//             {console.log("continuous",continuous)}
//             {console.log("step",step)}
//             {console.log(" index", index)}
//             {index > 0 && (
//                 <Button {...backProps}>
//                     <span id="back" >قبلی</span>
//                 </Button>
//             )}
//             {continuous && (
//                 <Button {...primaryProps}>
//                     <span id="next" >بعدی</span>
//                 </Button>
//             )}
//             {!continuous && (
//                 <Button {...closeProps}>
//                     <span id="close" >اتمام راهنما</span>
//                 </Button>
//             )}
//         </TooltipFooter>
//     </TooltipBody>
// );